







































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';

import {
  Country,
  City,
  StoreAccount,
  AdSpace,
  AdSpaceScreensPosition,
  AdSPaceScreenSaver,
  AdSpacePriceControl,
  RegulatorAccount,
  Region,
  FrequencyPricing,
  PricingSelection, Media, MediaType,
} from '@/app/shared/utilities/static-types';
import { STORE_PRICE_CONTROL, STORE_TYPES } from '@/app/shared/utilities/object-factory';
import {
  getStoresAction,
} from '@globalActions/DevicesActions';
import {
  getCountriesAction,
  getCitiesByCountryCodeAction,
} from '@/app/shared/utilities/geonames-transformer';
import rules from '@/app/shared/validation-rules';
import { AdminRoutes } from '@/app/shared/utilities/routes-names';
import FormComponent from '@/app/shared/components/FormComponent.vue';
import {
  updateAdSpaceAction,
  loadAdSpaceByIdAction,
} from '@adSpaces/shared/actions';
import { isAdminUserAction, isStoreOwnerAction } from '@globalActions/UserRolesActions';
import AdSpaceMediaUpload from '@adSpaces/screens/StoreOwner/screens/components/AdSpaceMediaUpload.vue';
import { getBlobFromImageSrc } from '@/app/shared/utilities/helper-functions';
import CreateAdSpaceScreenSaver from '@adSpaces/screens/StoreOwner/screens/AdSpaceNew/Components/CreateAdSpaceScreenSaver/CreateAdSpaceScreenSaver.vue';
import AdSpaceScreenSaverList from '@adSpaces/screens/StoreOwner/screens/AdSpaceNew/Components/AdSpaceScreenSaverList/AdSpaceScreenSaverList.vue';
import { loadRegulators } from '@adminStores/shared/actions';
import { getRegionByCityGeonameId } from '@/app/shared/utilities/geonames-transformer';
import { cloneDeep, flow } from 'lodash';
import firebase from 'firebase';
import PreviewThumbnail from '@campaigns/shared/components/PreviewThumbnail.vue';
import * as actions from '@userApp/shared/actions';
import storage = firebase.storage;

@Component({
  components: {
    PreviewThumbnail,
    AdSpaceMediaUpload,
    FormComponent,
    CreateAdSpaceScreenSaver,
    AdSpaceScreenSaverList,
  },
  data: (vm: any) => ({
    requiredRules: [rules.required(vm.$i18n.t('field_required'))],
    adSpaceScreensPositions: Object.values(AdSpaceScreensPosition).map((val) => ({
      VAL: val,
      TEXT: vm.$i18n.t(val),
    })),
  }),
})
export default class AdSpaceEdit extends Vue {
  public loading = true;
  public uploading = false;
  public allAdSpacesRoute = AdminRoutes.ALL_AD_SPACES;
  public storePriceControl = STORE_PRICE_CONTROL;
  public regulators: RegulatorAccount[] = [];
  public regulator: RegulatorAccount | null = null;
  public regulatorsMap: Map<string, RegulatorAccount> = new Map();
  public storeTypes = STORE_TYPES;
  public countryArray: Country[] = [];
  public cityArray: City[] = [];
  public showCreateAdSpaceScreenSaver = false;
  public adSpace: AdSpace = {
    NAME: '',
    TYPE: {
      DISPLAY_NAME: 'Super Market',
      VAL: 'super-market',
    },
    COORDINATES: {},
    SCREENS_RESOLUTION: {
      UNIT: 'px',
    },
    SCREEN_SAVERS: [] as AdSPaceScreenSaver[],
    PRICE_CONTROL: AdSpacePriceControl.BY_SHASHA,
    FREQUENCY_PRICING: {
      PRICE_EVERY_CYCLE: 0,
      PRICE_EVERY_TWO_CYCLES: 0,
      PRICE_EVERY_FOUR_CYCLES: 0,
      PRICE_EVERY_EIGHT_CYCLES: 0,
    },
  } as unknown as AdSpace;

  public selectedMediaFiles: File[] = [];

  public loadCountries = getCountriesAction;

  public storeAccounts: StoreAccount[] = [];

  public isAdminUser = false;
  public isStoreOwner = false;
  public adSpacePricingScheme = 0;

  public get countries(): Country[] {
    return this.countryArray.map(
      (country) =>
        ({
          ...country,
          TEXT: this.$t(`countries.${country.DISPLAY_NAME}`).toString(),
        } as Country),
    );
  }

  public get cities(): City[] {
    return this.cityArray!.map(
      (city) =>
        ({
          ...city,
          TEXT: this.$t(`cities.${city.DISPLAY_NAME.en}`).toString(),
        } as City),
    );
  }

  public get isFactorPricing() {
    return this.adSpacePricingScheme === PricingSelection.FACTOR_PRICING;
  }

  public get isFrequencyPricing() {
    return this.adSpacePricingScheme === PricingSelection.FREQUENCY_PRICING;
  }

  public updateRegulator(regulatorId: string) {
    return this.regulator = this.regulators.find((regulator) => regulator.UID === regulatorId) || null;
  }

  public async loadData() {
    this.loading = true;
    this.adSpace = { ...this.adSpace, ...(await this.loadAdSpace()) };
    try {
      this.selectedMediaFiles = [];
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.log(e);
    }
    const isFrequencyPricing = this.adSpace.IS_FREQUENCY_PRICING;
    if (isFrequencyPricing) {
      this.adSpacePricingScheme = PricingSelection.FREQUENCY_PRICING;
    }
    this.loadCities(this.adSpace.COUNTRY);
    this.countryArray = this.loadCountries();
    this.regulators = await loadRegulators();
    this.regulatorsMap = new Map(this.regulators.map((regulator) => [regulator.UID || '', regulator]));
    this.updateRegulator(this.adSpace.REGULATOR_ID);
    this.isAdminUser = await isAdminUserAction();
    this.isStoreOwner = await isStoreOwnerAction();
    this.storeAccounts = await getStoresAction();
    this.loading = false;
  }

  public loadCities(country: Country) {
    this.cityArray = getCitiesByCountryCodeAction(country);
  }

  public async loadAdSpace() {
    try {
      this.loading = true;
      const loadedId = this.$route.params.id;
      if (!loadedId) {
        this.$router.push(this.allAdSpacesRoute);
        throw new Error('Error loading adspace.');
      }

      return loadAdSpaceByIdAction(loadedId);
    } finally {
      this.loading = false;
    }
  }

  public async updateAdSpace() {
    // AdSpace factory following SOLID principles
    const adSpaceFactory = {
      createAdSpaceData: (): AdSpace =>
         cloneDeep(this.adSpace)
      ,

      applyPricingStrategy: (adSpace: AdSpace): AdSpace => {
        adSpace.IS_FREQUENCY_PRICING = this.adSpacePricingScheme === PricingSelection.FREQUENCY_PRICING;

        return adSpace;
      },
    };

    // Using declarative approach with function composition
    await flow([
      adSpaceFactory.createAdSpaceData,
      adSpaceFactory.applyPricingStrategy,
      updateAdSpaceAction,
    ])();
    await this.startUploadingMedia();
    this.$router.push(this.allAdSpacesRoute);
  }

  @Watch('$root.$i18n.locale')
  public onChangeLocale(val: string, oldVal: string) {
    const [prevSelectedCountry, prevSelectedCity] = [
      this.adSpace.COUNTRY,
      this.adSpace.CITY,
    ];

    this.countryArray = this.loadCountries();

    if (prevSelectedCountry) {
      this.adSpace.COUNTRY = this.countries.find(
        (country) => country.GEONAME_ID === prevSelectedCountry.GEONAME_ID,
      )!;
      this.loadCities(prevSelectedCountry);
    }

    if (prevSelectedCity) {
      this.adSpace.CITY = this.cities.find(
        (city) => city.GEONAME_ID === prevSelectedCity.GEONAME_ID,
      )!;
    }
  }
  public adSpaceScreenSaverCreated(adSpaceScreenSaver: AdSPaceScreenSaver) {
    this.adSpace.SCREEN_SAVERS = this.adSpace.SCREEN_SAVERS.concat(adSpaceScreenSaver);
  }
  public reorderMapper(adSpaceScreenSaver: AdSPaceScreenSaver, index: number) {
    adSpaceScreenSaver.ORDER = index + 1;
    return adSpaceScreenSaver;
  }
  public adSpaceScreenSaverDeleted(screenSaverMediaPath: string) {
    this.adSpace.SCREEN_SAVERS = this.adSpace.SCREEN_SAVERS
        .filter((adSpaceScreenSaver) => adSpaceScreenSaver.MEDIA_FILE.MEDIA_FILE !== screenSaverMediaPath)
        .map(this.reorderMapper);
  }
  public adSpaceScreenSaverReordered(adSpaceScreenSavers: AdSPaceScreenSaver[]) {
    this.adSpace.SCREEN_SAVERS = adSpaceScreenSavers.map(this.reorderMapper);
  }

  @Watch('adSpace.COUNTRY')
  public countryChanged(newCountry: Country, oldCountry: Country) {
    if (oldCountry && newCountry && oldCountry.GEONAME_ID !== newCountry.GEONAME_ID) {
      this.adSpace.REGION = {} as Region;
      if (this.adSpace.CITY && this.adSpace.CITY.GEONAME_ID) {
        const region = getRegionByCityGeonameId(this.adSpace.CITY.GEONAME_ID);
        if (region) {
          this.adSpace.REGION = region;
        }
      }
    }
  }

  @Watch('adSpace.CITY', { deep: true })
  public cityChanged(newData: City, oldData: City) {
    if (!this.adSpace.CITY || !newData || !newData.GEONAME_ID) {
      return;
    }

    if (!oldData || oldData.GEONAME_ID !== newData.GEONAME_ID) {
      const region = getRegionByCityGeonameId(newData.GEONAME_ID);
      this.adSpace.CITY = newData;

      if (region) {
        this.adSpace.REGION = region;
      } else {
        this.adSpace.REGION = {} as Region;
      }
    }
  }

  public async startUploadingMedia() {
    try {
      this.uploading = true;
      if (!this.selectedMediaFiles || this.selectedMediaFiles.length === 0) {
        return;
      }

      const uploadedMediaLinks = await Promise.all(
          this.selectedMediaFiles.map(async (file) => {
            const uploadTaskRef = await actions.uploadMediaForAdSpace(file, this.adSpace);
            const uploadTask = uploadTaskRef.put(file);
            return new Promise<Media>((resolve) => {
              uploadTask.on(
                  storage.TaskEvent.STATE_CHANGED,
                  null,
                  (error: Error) => {
                    this.uploading = false;
                    /* tslint:disable-next-line */
                    console.error(error);
                  },
                  async () => {
                    const mediaLink =
                        uploadTask && (await uploadTask.snapshot.ref.getDownloadURL());

                    const mediaFileData: Media = {
                      TYPE: file.type as MediaType,
                      PATH: mediaLink,
                    };

                    resolve(mediaFileData);
                  },
              );
            });
          }));
      await updateAdSpaceAction({
        ID: this.adSpace.ID,
        MEDIA: uploadedMediaLinks,
        MEDIA_FILE: uploadedMediaLinks[0].PATH,
        MEDIA_TYPE: uploadedMediaLinks[0].TYPE,
      });
      this.selectedMediaFiles = [];
      this.uploading = false;
    } catch (error) {
      this.uploading = false;
    }
  }
}
